import type { TrackingIdentity } from './trackingIdentity'

export const SHARED_IDENTITY_COOKIE_PREFIXES: Record<TrackingIdentity, ReadonlyArray<string>> = {
  domain: ['lux_sp_domain_user_id'],
  stitched: ['lux_stitched_seed_id_', 'LK_M_ID'],
}

export const PURPOSE_IDENTIFIER_COOKIE_PREFIXES = {
  analytics: ['_sp_', 'lux_sp_', '_hj', '_dd_s'],
  personalisation: [],
  experimentation: ['optimizely', 'cherto_', 'OXPT'],
  advertising: ['_ga', '_gid', '_gcl', '__gads', '__gpi', '_fbp', '_fbc', 'ab.'],
} as const

export const PURPOSE_IDENTIFIER_STORAGE_PREFIXES = {
  analytics: ['_sp_', '_hj'],
  personalisation: [],
  experimentation: ['optimizely', 'cherto_', 'OXPT'],
  advertising: ['ab.storage', '_ga'],
} as const

export function matchesIdentifierPrefix(name: string, prefixes: ReadonlyArray<string>): boolean {
  return prefixes.some(prefix => name === prefix || name.startsWith(prefix))
}
